module.exports = __webpack_public_path__ + "static/media/unimarconi.c534b17c.png";